import { SettingsApiLogsTab } from "@/components/settings/SettingsApiLogsTab";

export function SettingsApiLogsPage() {
  return <SettingsApiLogsTab />;
}
